import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CartBaseFragment = { id: string, token: any, count: number, quantity: number, type: Types.CartTypeEnum, orderId: number | null };

export type CartTotalPriceFragment = { id: string, promoCodeApplied: number, earnPoints: number, currency: string, undiscount: { currency: string, gross: number }, discount: { currency: string, gross: number }, discountUsd: { currency: string, gross: number } };

export const CartBaseFragmentDoc = gql`
    fragment CartBaseFragment on CartType {
  id
  token
  count
  quantity
  type
  orderId
}
    `;
export const CartTotalPriceFragmentDoc = gql`
    fragment CartTotalPriceFragment on CartTotalPriceType {
  id
  undiscount {
    currency
    gross
  }
  discount {
    currency
    gross
  }
  discountUsd {
    currency
    gross
  }
  promoCodeApplied
  earnPoints
  currency
}
    `;